<template>
    <div class="form-page">
        <my-form v-model="form" readonly table>
            <my-form-item-group title="投标人澄清问题-详情">
                <el-form-item label="问题标题" prop="yqcqwttitle" class="table-full-row">
                    {{form.yqcqwttitle||'-'}}
                </el-form-item>
                 <el-form-item label="要求澄清的问题" prop="yqcqwt" class="table-full-row">
                    <div v-html="form.yqcqwt"></div>
                </el-form-item>
                  <el-form-item label="附件" class="table-full-row">
                    <yygl-upload v-if="isnm == '1' || isnm == '2'" readonly  :file-guid="form.fileguid"></yygl-upload>
                    <my-upload v-else readonly  :file-guid="form.fileguid"></my-upload>
                </el-form-item> 
            </my-form-item-group>
            <my-form-item-group title="回复问题">
                <el-form-item label="回复内容" prop="exthfcontent" class="table-full-row">
                     <el-input v-html="form.exthfcontent"  type="textarea" :rows="4"></el-input>
                </el-form-item>
             
            </my-form-item-group>
        </my-form>
    </div>
</template>

<script>
import LIST_PAGE_MIXIN from '@views/mixins/list-page'
import yyglUpload from './components/yygl-upload'
export default {
    mixins: [LIST_PAGE_MIXIN],
    components:{yyglUpload},
    data() {
        return{
            form:{},
            isnm:"",
        }
    },
    computed: {
        
    },
    watch: {

    },
    methods: {


    },
    created() {
         this.$get(`${this.getGetters('bidUrl')}/FaBiao/CqWt/detail.json`, {
            id: this.getQuery('id'),
            procode:this.getQuery('procode'),
        }, data => {
            this.form=data.model;
            this.isnm = !!data.isnm ? data.isnm : '0';
        });
        
    },
    mounted() {
        
    }
}
</script>

<style scoped lang="scss">

</style>
